// South African 13-digit ID validation: format + DOB sanity + citizenship digit + Luhn checksum.
// Returns an error string, or null when valid.
export function validateSAID(raw) {
  const id = (raw || "").replace(/\D/g, "");
  if (id.length !== 13) return "ID number must be 13 digits.";
  const mm = +id.slice(2, 4);
  const dd = +id.slice(4, 6);
  if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return "Check the date of birth in your ID number.";
  if (!["0", "1"].includes(id[10])) return "That doesn't look like a valid SA ID number.";
  let total = 0;
  id.split("").reverse().forEach((c, i) => {
    let d = +c;
    if (i % 2 === 1) { d *= 2; if (d > 9) d -= 9; }
    total += d;
  });
  if (total % 10 !== 0) return "ID checksum is invalid — please double-check.";
  return null;
}
